import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import AffiliateCard from "./AffiliateCard";
import check from "../../images/utils/verify.png";
import SEO from "../utils/SEO";

const AffiliateRequest = () => {
  return (
    <Container style={{ marginBottom: "50px" }}>
      <SEO
        title="Become a Sarv Affiliate - Earn by Promoting Holistic Health"
        description="Join the Sarv affiliate program as a content creator or business partner. Earn 20% commission on every paid subscription you bring in, and share an exclusive 20-30% discount with your audience."
        canonicalPath="/affiliate-request"
        keywords="holistic health affiliate program, herbal medicine affiliate, wellness affiliate, content creator affiliate, Sarv affiliate, natural health commission, holistic health partnership"
      />
      <Row>
        <Col md={6}>
          <Row style={{ paddingTop: "50px" }}>
            <p
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "darkgreen",
              }}
            >
              Partner With Sarv. Get Paid To Share What You Love.
            </p>
          </Row>
          <Row>
            <p>
              Whether you're a content creator with an engaged audience or a
              business looking to bring holistic wellness to your community,
              Sarv's affiliate program lets you share personalized natural
              healing with the people who trust you — and earn while you do it.
              You get a unique promo code that gives your audience{" "}
              <b>20-30% off</b> Sarv subscriptions, and you earn{" "}
              <b>20% commission</b> on every paid subscription that converts
              after the 3-day free trial.
            </p>
          </Row>

          <Row>
            <p
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "darkgreen",
              }}
            >
              For Content Creators
            </p>
          </Row>
          <Row>
            <ul style={{ listStyleType: "none" }}>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>Your own promo code:</b> Get a personalized code to share on
                Instagram, TikTok, YouTube, your podcast, or anywhere your
                audience lives.
              </li>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>20% on every paid subscription:</b> Commission kicks in the
                moment your referral converts past their 3-day free trial — no
                payouts on free trials that don't convert.
              </li>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>Real-time dashboard:</b> See your trials, conversions,
                pending earnings, and payouts in your own affiliate dashboard.
              </li>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>Aligned mission:</b> Promote a product that genuinely helps
                people — personalized herbal medicine, recipes, and wellness
                guidance grounded in tradition and modern science.
              </li>
            </ul>
          </Row>

          <Row>
            <p
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "darkgreen",
              }}
            >
              For Businesses & Wellness Partners
            </p>
          </Row>
          <Row>
            <ul style={{ listStyleType: "none" }}>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>Wellness for your members:</b> Bring personalized holistic
                health solutions to employees, clients, or members at a
                discounted rate.
              </li>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>Co-marketing opportunities:</b> Joint campaigns, content,
                and events with a fast-growing holistic wellness brand.
              </li>
              <li>
                <img
                  src={check}
                  alt="Check"
                  style={{
                    width: "20px",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                />
                <b>Privacy & security first:</b> HIPAA-mindful infrastructure
                and rigorous data handling so you can recommend Sarv with
                confidence.
              </li>
            </ul>
            <p
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "darkgreen",
              }}
            >
              How It Works
            </p>
            <p>
              Apply with the form on the right. Once approved, we'll email you
              your unique promo code and dashboard login. Share your code with
              your audience — they get 20-30% off, you earn 20% on each
              subscription that survives the 3-day trial. Track everything
              live, and we'll pay out on a regular cadence to whichever method
              you prefer.
            </p>
            <p style={{ fontSize: "14px" }}>
              Already approved?{" "}
              <Link to="/login">Log in to your dashboard</Link>.
            </p>
          </Row>
        </Col>
        <Col md={6}>
          <AffiliateCard />
          <p
            style={{
              paddingTop: "30px",
              paddingBottom: "50px",
              fontSize: "12px",
              paddingLeft: "15px",
              paddingRight: "15px",
            }}
          >
            "Through this form, Sarv will collect information including your
            name, email address, and details about you or your business. This
            information will only be retained for as long as needed to fulfill
            the purposes of evaluating your application, advertising, sales
            outreach, and partner support. By submitting, you consent to allow
            Sarv to store and process the personal information submitted above.
            For more information about how we use and retain your information,
            please see our <a href="/privacy-policy">Privacy Policy</a> and{" "}
            <a href="/terms-of-use">Terms of Use</a>."
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default AffiliateRequest;
